export const adminOnlyUpgradeModalName = 'ADMIN_ONLY_UPGRADE_MODAL';
export const changeActiveProjectsFailureDialogName = 'CHANGE_ACTIVE_PROJECTS_FAILURE_DIALOG';
export const changePlanModalName = 'CHANGE_PLAN_MODAL';
export const confirmUpgradeName = 'CONFIRM_UPGRADE';
export const v3ChangePlanModalName = 'V3_CHANGE_PLAN_MODAL';
export const v4ChangePlanModalName = 'V4_CHANGE_PLAN_MODAL';
